import React, { useState } from "react";
import Image from "../../../components/elements/Image";
import Input from "../../../components/form/Input";
import Button from "../../../components/forms/Button";
import { classNames } from "../../../helpers/classNames";
import Logo from "../../../assets/images/logo-memory-doodle-stack.svg";
import GoogleLogo from "../../../assets/image/google.svg";
import FacebookLogo from "../../../assets/image/facebook.svg";
import { forgetPassword } from "../../../services/authService";
import { useLocation, useNavigate } from "react-router-dom";
import useMutation from "../../../hooks/useMutation";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const { mutate, error, isPending, data } = useMutation({
    mutationFn: async (val) => {
      return await forgetPassword({
        ...val,
        email: location?.state?.email || email,
      });
    },
    onSuccess: async (res) => {
      if (res?.status === 200) {
        toast.success("Password reset email sent!");
        navigate("/signin");
      } else {
        toast.warning(res?.message || "Something went wrong");
      }
    },
  });

  return (
    <>
      <section className="relative min-h-[calc(100vh-6rem)] py-10 flex items-center overflow-hidden bg-md-pink-light-2">
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          <div className="w-full max-w-lg mx-auto space-y-8">
            <div className="h-36">
              <Image
                src={Logo}
                alt={""}
                width={"100%"}
                height={"100%"}
                effect={"blur"}
                classes={"object-contain"}
              />
            </div>
            <div className="relative bg-white shadow-md shadow-md-pink/10 py-6 px-6 rounded-xl space-y-6">
              <h2 className="text-2xl font-semibold text-md-dark text-center">
                Forgot your password
              </h2>
              <div className="space-y-4">
                <div className="relative">
                  <Input
                    inputPlaceholder={"Enter your email address"}
                    inputClasses={""}
                    labelClasses={
                      "!font-normal !text-sm !text-neutral-500 !mb-4"
                    }
                    label={
                      "Enter the email address associated with your account, and we'll send you a link to reset your password. If you don’t receive the email within a few minutes, please check your spam folder or try again."
                    }
                    inputType={"email"}
                    inputName="email"
                    inputValue={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {email && !isValidEmail(email) && (
                    <p className="text-sm text-red-500 mt-1">
                      Please enter a valid email address.
                    </p>
                  )}
                </div>
                <div className="relative !mt-8">
                  <Button
                    buttonLabel={isPending ? "Sending..." : "Continue"}
                    // isDisable={!email || isPending}
                    isDisable={!email || !isValidEmail(email) || isPending}
                    buttonClasses={"!rounded-md !pb-1 w-full"}
                    buttonLabelClasses={"!text-xl font-medium"}
                    // buttonHasLink={true}
                    // buttonLink={"/otp-verification"}
                    buttonFunction={() => mutate({})}
                  />
                </div>
              </div>
              <div className="text-center flex items-center justify-center text-base text-slate-400">
                <span>Already have an account?</span>
                <Button
                  buttonLabel={"Sign In"}
                  buttonLabelClasses={"!font-semibold"}
                  buttonClasses={
                    "!h-6 !px-1 !bg-white !text-md-pink !rounded-none hover:underline"
                  }
                  buttonHasLink={true}
                  buttonLink={"/signin"}
                />
                <span>here</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgotPassword;
